(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').controller('mx.SolutionBuilderAgent.ConcurrencyMergeController', MxConcurrencyMerge);

	MxConcurrencyMerge.$inject = ['mx.internationalization'];

	function MxConcurrencyMerge(i18n) {
		const vm = this;
		vm.i18n = i18n.get('solutionBuilderAgent.components.mx-concurrency-merge');

		vm.$onInit = function () {
			if (!Array.isArray(vm.conflictMergeEntities)) {
				return;
			}

			vm.decideMessage = i18n.getFormatted('solutionBuilderAgent.components.mx-concurrency-merge.decide', vm.conflictMergeEntities.length);

			vm.conflictMergeEntities.forEach(function (item) {
				item.UseNewValue = true;
				// item.AttributeType = 8;

				Object.defineProperty(item, 'useNewLocalValue', {
					enumerable: false,
					set: function (value) {
						item.UseNewValue = value;
						item.UseOldValue = !value;
					},
					get: function () {
						return item.UseNewValue;
					},
				});
			});
		};

		vm.cancel = function () {
			vm.answerPromise.resolve({ answer: 'cancel', mergeEntities: vm.conflictMergeEntities });
		};
		vm.mergeAndSave = function () {
			vm.answerPromise.resolve({ answer: 'mergeAndSave', mergeEntities: vm.conflictMergeEntities });
		};
		vm.merge = function () {
			vm.answerPromise.resolve({ answer: 'merge', mergeEntities: vm.conflictMergeEntities });
		};
	}
})();
